import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DpBaseStoreService {
  readonly #shopOpen$ = new BehaviorSubject<boolean>(false);

  get shopOpen(): boolean {
    return this.#shopOpen$.getValue();
  }

  setShopOpenValue(value: boolean): void {
    this.#shopOpen$.next(value);
  }

  isShopOpen$(): Observable<boolean> {
    return this.#shopOpen$.asObservable();
  }
}
